var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4343 14C15.4343 12.8954 16.3298 12 17.4343 12H22.2279C23.3324 12 24.2279 12.8954 24.2279 14V16.1198H15.4343V14ZM11.4343 16.4321V14C11.4343 10.6863 14.1206 8 17.4343 8H22.2279C25.5416 8 28.2279 10.6863 28.2279 14V16.7172C29.3659 17.4224 30.1238 18.6826 30.1238 20.1198V26.0258C30.1238 28.2349 28.333 30.0258 26.1238 30.0258H12.9867C10.7775 30.0258 8.98666 28.2349 8.98666 26.0258V23.2383H9.10155C9.32043 23.2383 9.53864 23.2622 9.75231 23.3097L18.4689 25.2466C19.1832 25.4053 19.9238 25.4053 20.6381 25.2466L29.3541 23.3097C29.5678 23.2622 29.786 23.2383 30.0049 23.2383H30.1221V21.2383H30.0049C29.6401 21.2383 29.2764 21.2782 28.9203 21.3573L20.2043 23.2942C19.7756 23.3895 19.3313 23.3895 18.9027 23.2942L10.1861 21.3573C9.83004 21.2782 9.46634 21.2383 9.10155 21.2383H8.98666V20.1198C8.98666 18.4611 9.9962 17.0383 11.4343 16.4321ZM8.98666 21.2383H8.98438V23.2383H8.98666V21.2383Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookings);
export default __webpack_public_path__ + "static/media/bookings.e7c993a7f8dcdb5fa3d63721a703429a.svg";
export { ForwardRef as ReactComponent };